import {closestCenter, pointerWithin, rectIntersection} from "@dnd-kit/core";

// A list can only sort against lists, never against their nested cards.
export const boardCollisionDetection = (args) => {
    const draggingList = args.active.data.current?.type === "list";
    const droppableContainers = args.droppableContainers.filter((container) =>
        draggingList
            ? container.data.current?.type === "list"
            : ["list", "card"].includes(container.data.current?.type)
    );
    const scopedArgs = {...args, droppableContainers};
    const hits = pointerWithin(scopedArgs);

    if (draggingList) {
        return hits.length ? hits : closestCenter(scopedArgs);
    }

    // Inside a column, prefer the card under the pointer; its blank area
    // remains a valid target for appending, including to an empty column.
    const collisions = args.pointerCoordinates ? hits : rectIntersection(scopedArgs);
    const cardHits = collisions.filter(({id}) =>
        droppableContainers.find((container) => container.id === id)?.data.current?.type === "card"
    );
    return cardHits.length ? cardHits : collisions;
};
